import React, { useEffect } from "react"
import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useHistory,
} from "react-router-dom"

import { useAuth } from "./AuthProvider"
import { SignInWarning } from "./SignInWarning"

import { BrowseFeatureLayers } from "../feature-layer/BrowseFeatureLayers"
import { FeatureLayerEditor } from "../feature-layer/FeatureLayerEditor"
import { FeatureLayerSettings } from "../featuer-layer-settings/FeatureLayerSettings"

export const AppRoutes = () => {
  const { status } = useAuth()

  /** Redirect if the featureLayerId is undefined */
  const match = useRouteMatch<{ featureLayerId?: string }>(
    "/layers/:featureLayerId"
  )
  const history = useHistory()
  useEffect(() => {
    if (match?.params.featureLayerId === "undefined") {
      history.push("/layers")
    }
  })

  return status === "signedIn" ? (
    <Switch>
      <Route path="/layers/:featureLayerId/settings">
        <FeatureLayerSettings />
      </Route>
      <Route path="/layers/:featureLayerId">
        <FeatureLayerEditor />
      </Route>
      <Route path="/layers">
        <BrowseFeatureLayers />
      </Route>
      <Redirect to="/layers" />
    </Switch>
  ) : (
    <SignInWarning />
  )
}
